import { render, staticRenderFns } from "./tabBar.vue?vue&type=template&id=488e8599&scoped=true&"
import script from "./tabBar.ts?vue&type=script&lang=js&"
export * from "./tabBar.ts?vue&type=script&lang=js&"
import style0 from "./tabBar.less?vue&type=style&index=0&id=488e8599&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e8599",
  null
  
)

export default component.exports